import { SET_FEATURE_FLAGS } from '@/utils/store/mutationTypes'

export default {
  [SET_FEATURE_FLAGS] (state, { flags }) {
    state.flags = flags
  }
}
